import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {FormFieldProperty} from "../../models/form-field-property";

@Injectable()
export class FieldPropertiesControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getFieldPropertiesList(serviceId: string): Observable<FormFieldProperty[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/field_properties_relations") as Observable<FormFieldProperty[][]> ;
  }

}
